import React from "react";

interface Props {
	max: number;
	answered: number;
}

const ProgressBar: React.FC<Props> = ({max, answered}: Props) => {
	return (
		<div className="cih-progress-container">
			<label className="cih-label" htmlFor="progress">Progress</label>
			<div className="cih-progress">
				<div className="progress-bar" style={{ width: (answered/max) * 100 + "%" }}></div>
			</div>
		</div>
	);
};

export default ProgressBar;
